import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'
import i18n from 'live/services/i18n'

import { ImageLogColorScale } from 'live-charts/types/image-log'

// TODO: consider showing the color scale gradient itself instead of the name

type ColorScaleSelectorProps = {
    onChange: (value: ImageLogColorScale) => void
    value: ImageLogColorScale
    noFormGroup?: boolean
    hideLabel?: boolean
}

export const getLabel = (colorScale: ImageLogColorScale): string => {
    switch (colorScale) {
        case ImageLogColorScale.YellowOrangeBrown:
            return i18n('Yellow/Orange/Brown')
        case ImageLogColorScale.YellowOrangeRed:
            return i18n('Yellow/Orange/Red')
        case ImageLogColorScale.YellowGreenBlue:
            return i18n('Yellow/Green/Blue')
        default:
            return i18n('Invalid color scale type')
    }
}

const ColorScaleSelector = ({
    onChange,
    value,
    noFormGroup = false,
    hideLabel = false
}: ColorScaleSelectorProps): React.ReactElement => (
    <LiveSelect
        label={hideLabel ? null : i18n('Color pattern')}
        options={[
            { label: getLabel(ImageLogColorScale.YellowOrangeBrown), value: ImageLogColorScale.YellowOrangeBrown },
            {
                label: getLabel(ImageLogColorScale.YellowOrangeRed),
                value: ImageLogColorScale.YellowOrangeRed
            },
            { label: getLabel(ImageLogColorScale.YellowGreenBlue), value: ImageLogColorScale.YellowGreenBlue }
        ]}
        value={value}
        placeholder={i18n('Select color pattern')}
        onChange={onChange}
        clearable={false}
        searchable={false}
        menuOnPortal={false}
        noFormGroup={noFormGroup}
    />
)

export default ColorScaleSelector
